/**
 * Indian-format currency helpers.
 * ₹1,00,000.50 instead of $100,000.50
 */

const INR = new Intl.NumberFormat("en-IN", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const INR_INT = new Intl.NumberFormat("en-IN", {
  maximumFractionDigits: 0,
});

/** ₹1,23,456.78 — always with the ₹ symbol. Safe on NaN / null. */
export function inr(n) {
  const num = Number(n);
  if (!isFinite(num)) return "₹0.00";
  return "₹" + INR.format(num);
}

/** Same but without decimals — for round numbers like salaries. */
export function inrRound(n) {
  const num = Number(n);
  if (!isFinite(num)) return "₹0";
  return "₹" + INR_INT.format(num);
}

/** Plain number in Indian grouping (no ₹). */
export function inrNumber(n, decimals = 2) {
  const num = Number(n);
  if (!isFinite(num)) return decimals ? "0.00" : "0";
  return new Intl.NumberFormat("en-IN", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(num);
}

/** Clamp to >= 0 for form inputs. */
export function clampNonNegative(v) {
  const n = parseFloat(v);
  return isFinite(n) && n >= 0 ? n : 0;
}
